<script>
  import copy from 'clipboard-copy';
  import { onMount } from 'svelte';
  import { CodeSnippet } from 'carbon-components-svelte';

  import { getAccount } from '../services';

  export let roleName;
  let account;

  onMount(async () => {
    account = await getAccount();
  });

  $: roleArn = account?.account ? `arn:aws:iam::${account.account}:role/${roleName}` : '';
</script>

<div class="role-arn-value">
  <CodeSnippet code={roleArn} {copy} />
</div>

<style>
  .role-arn-value {
    min-width: 0;
  }

  .role-arn-value :global(.bx--snippet-container) {
    overflow: hidden;
  }

  .role-arn-value :global(.bx--snippet--single pre) {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
